import styled from "styled-components";

export const FormContainer = styled("div")`
  #root_inventoryTicker {
    width: 200px;
  }  
  
  #root_phone {
    margin-bottom: 30px;
  }
`;
